var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('controls'),_c('data-table',{attrs:{"items":_vm.reportItems,"fields":_vm.reportFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }